"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _getProductsNoAuth = require("self-service-api/api/getProductsNoAuth");

// This is just a pointer to getProductsNoAuth now to maintain backwards compatibility. Should remove the
// getProductsNoAuth or copy its code into here once we can move all references to this
var _default = _getProductsNoAuth.getProducts;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.1360/js/api/getProducts.js
// module id = 724
// module chunks = 5 6